<template>
  <div class="g-tabbar">
    <template v-for="(item,index) in items">
      <a :key="index" class="g-tabbar-item" :href="item.url">
        <img class="tabbar-image" :src="item.icon" />
        <span class="tabbar-text">{{item.text}}</span>
      </a>
    </template>
  </div>
</template>

<script>
  import items from './config';

  export default {
    name: 'CTabbar',
    created() {
      this.items = items;
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

a:active {
  color: $text-color;
}
</style>
